// ChartsDashboard.jsx
import React from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
} from 'chart.js';
import { Doughnut, Line } from 'react-chartjs-2';
import { formatDecimalPercentage } from '../../../../common/common';

ChartJS.register(
  ArcElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const ChartsDashboard = ({ blockData, totalCustomers }) => {
  const doughnutData = {
    labels: [`Champions (${blockData.champions.percentage}%)`, `Loyalists (${formatDecimalPercentage(blockData.loyalists.percentage)}%)`, `Potential (${blockData.potential.percentage}%)`, `New (${blockData.new.percentage}%)`, `At Risk (${blockData.atRisk.percentage}%)`, `Hibernating (${blockData.hibernating.percentage}%)`, `Others (${blockData.others.percentage}%)`],
    datasets: [
      {
        data: [blockData.champions.percentage, (blockData.loyalists.percentage), blockData.potential.percentage, blockData.new.percentage, blockData.atRisk.percentage, blockData.hibernating.percentage, blockData.others.percentage],
        backgroundColor: [
          'rgba(54, 162, 235, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(255, 99, 132, 0.8)',
          'rgba(153, 102, 255, 0.8)',
          'rgba(201, 203, 207, 0.8)',
          'rgba(157, 214, 91, 0.8)'
        ],
      },
    ],
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom' },
    },
    cutout: '65%',
  };

  const lineData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Sales Performance',
        data: [32000, 35000, 39000, 37000, 42000, 71000, 68000],
        borderColor: 'rgba(59, 130, 246, 1)',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        tension: 0.4,
        fill: true,
      },
    ],
  };

  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: false,
        grid: { drawBorder: false },
      },
      x: {
        grid: { display: false },
      },
    },
  };

  return (
    <div className="grid grid-cols-1  gap-6">
      {/* Doughnut Chart */}
      <div className="bg-white from-blue-50 to-white rounded-xl p-4 h-[350px]">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-medium">Customer Distribution</h3>
          <div className="text-xs">
            <span className="font-medium">Total:</span> {totalCustomers} Customers
          </div>
        </div>
        <Doughnut data={doughnutData} options={doughnutOptions} />
      </div>

      {/* Line Chart */}
      {/* <div className="bg-gradient-to-b from-blue-50 to-white rounded-xl p-4 h-[350px]">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-medium">Weekly Sales Trend</h3>
        </div>
        <Line data={lineData} options={lineOptions} />
      </div> */}
    </div>
  );
};

export default ChartsDashboard;
